/**
 * Zoom que acompanha o cursor nos cards de produto.
 *
 * Ao passar o mouse sobre a foto do card, a imagem amplia e o ponto ampliado
 * segue o cursor, permitindo inspecionar qualquer parte do produto.
 *
 * O nível de zoom vem da variável CSS --product-card-zoom (definida no
 * theme.css). Só roda em dispositivos com mouse: no celular o toque abre o
 * produto normalmente.
 *
 * Usa delegação de eventos porque o tema recria os cards via AJAX
 * (filtros, paginação, busca, mega menu).
 */
(() => {
  const FIGURE = '.product-card__figure';
  const ZOOMING = 'is-zooming';

  const finePointer = window.matchMedia('(pointer: fine)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const canZoom = (figure) => {
    // Cards configurados para trocar pela segunda imagem mantêm o comportamento antigo.
    if (!figure || figure.closest('.product-card--show-secondary-media')) return false;

    const image = figure.querySelector('.product-card__image--primary');
    if (!image) return false;

    // Zoom em 100% (ou menos) significa desligado nas configurações do tema.
    const level = parseFloat(getComputedStyle(image).getPropertyValue('--product-card-zoom'));
    return !Number.isFinite(level) || level > 1;
  };

  const track = (figure, event) => {
    const rect = figure.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    const x = ((event.clientX - rect.left) / rect.width) * 100;
    const y = ((event.clientY - rect.top) / rect.height) * 100;

    figure.style.setProperty('--zoom-x', `${Math.min(Math.max(x, 0), 100)}%`);
    figure.style.setProperty('--zoom-y', `${Math.min(Math.max(y, 0), 100)}%`);
  };

  const release = (figure) => {
    figure.classList.remove(ZOOMING);
    figure.style.removeProperty('--zoom-x');
    figure.style.removeProperty('--zoom-y');
    figure.removeEventListener('pointermove', figure._zoomMove);
    figure.removeEventListener('pointerleave', figure._zoomLeave);
    delete figure._zoomMove;
    delete figure._zoomLeave;
  };

  document.addEventListener('pointerover', (event) => {
    if (event.pointerType !== 'mouse' || !finePointer.matches || reducedMotion.matches) return;

    const figure = event.target.closest?.(FIGURE);
    if (!figure || figure._zoomMove || !canZoom(figure)) return;

    // Posiciona a origem antes de ampliar, para a imagem não saltar ao entrar.
    track(figure, event);
    figure.classList.add(ZOOMING);

    figure._zoomMove = (moveEvent) => track(figure, moveEvent);
    figure._zoomLeave = () => release(figure);

    figure.addEventListener('pointermove', figure._zoomMove);
    figure.addEventListener('pointerleave', figure._zoomLeave);
  });

  // Se o card for removido do DOM ainda ampliado (troca de página via AJAX),
  // não fica listener órfão preso a um elemento morto.
  document.addEventListener('pointercancel', (event) => {
    const figure = event.target.closest?.(FIGURE);
    if (figure && figure._zoomMove) release(figure);
  });
})();
